export const SuperAdminRoleID = '0199bbda-1be4-76ac-a3aa-13be8b997edf'
export const AdminRoleID = '0199bbda-7546-7a66-876e-3dd709f7709d'
export const UserRoleID = '0199bbda-8957-7d55-a4d7-7227a316aa9d'
